/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShowcaseIndexRouteImport } from './routes/showcase/index'
import { Route as ShowcaseSlugRouteImport } from './routes/showcase/$slug'
import { Route as ApplyMemberRouteImport } from './routes/apply/member'
import { Route as ApplyEnterpriseRouteImport } from './routes/apply/enterprise'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedMemberRouteRouteImport } from './routes/_authenticated/member/route'
import { Route as AuthenticatedEnterpriseRouteRouteImport } from './routes/_authenticated/enterprise/route'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedMemberIndexRouteImport } from './routes/_authenticated/member/index'
import { Route as AuthenticatedEnterpriseIndexRouteImport } from './routes/_authenticated/enterprise/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedMemberSavedRouteImport } from './routes/_authenticated/member/saved'
import { Route as AuthenticatedMemberPocEnvironmentRouteImport } from './routes/_authenticated/member/poc-environment'
import { Route as AuthenticatedMemberMyApplicationsRouteImport } from './routes/_authenticated/member/my-applications'
import { Route as AuthenticatedEnterprisePocEnvironmentRouteImport } from './routes/_authenticated/enterprise/poc-environment'
import { Route as AuthenticatedEnterpriseNewRouteImport } from './routes/_authenticated/enterprise/new'
import { Route as AuthenticatedAdminUsageRouteImport } from './routes/_authenticated/admin/usage'
import { Route as AuthenticatedAdminMemberRegisterRouteImport } from './routes/_authenticated/admin/member-register'
import { Route as AuthenticatedAdminEnterpriseRegisterRouteImport } from './routes/_authenticated/admin/enterprise-register'
import { Route as AuthenticatedAdminAdminRegisterRouteImport } from './routes/_authenticated/admin/admin-register'
import { Route as AuthenticatedMemberCompaniesRouteRouteImport } from './routes/_authenticated/member/companies/route'
import { Route as AuthenticatedMemberIdRouteRouteImport } from './routes/_authenticated/member/$id/route'
import { Route as AuthenticatedEnterpriseIdRouteRouteImport } from './routes/_authenticated/enterprise/$id/route'
import { Route as AuthenticatedAdminOrganizationsRouteRouteImport } from './routes/_authenticated/admin/organizations/route'
import { Route as AuthenticatedAdminCasesRouteRouteImport } from './routes/_authenticated/admin/cases/route'
import { Route as AuthenticatedMemberCompaniesIndexRouteImport } from './routes/_authenticated/member/companies/index'
import { Route as AuthenticatedMemberIdIndexRouteImport } from './routes/_authenticated/member/$id/index'
import { Route as AuthenticatedEnterpriseApplicationsIndexRouteImport } from './routes/_authenticated/enterprise/applications/index'
import { Route as AuthenticatedEnterpriseActiveIndexRouteImport } from './routes/_authenticated/enterprise/active/index'
import { Route as AuthenticatedEnterpriseIdIndexRouteImport } from './routes/_authenticated/enterprise/$id/index'
import { Route as AuthenticatedAdminOrganizationsIndexRouteImport } from './routes/_authenticated/admin/organizations/index'
import { Route as AuthenticatedAdminKakekomiIndexRouteImport } from './routes/_authenticated/admin/kakekomi/index'
import { Route as AuthenticatedAdminInquiriesIndexRouteImport } from './routes/_authenticated/admin/inquiries/index'
import { Route as AuthenticatedAdminCasesIndexRouteImport } from './routes/_authenticated/admin/cases/index'
import { Route as AuthenticatedAdminApplicationsIndexRouteImport } from './routes/_authenticated/admin/applications/index'
import { Route as AuthenticatedMemberIdApplyRouteImport } from './routes/_authenticated/member/$id/apply'
import { Route as AuthenticatedEnterpriseIdEditRouteImport } from './routes/_authenticated/enterprise/$id/edit'
import { Route as AuthenticatedAdminOrganizationsMembersRouteImport } from './routes/_authenticated/admin/organizations/members'
import { Route as AuthenticatedAdminOrganizationsCompaniesRouteImport } from './routes/_authenticated/admin/organizations/companies'
import { Route as AuthenticatedAdminKakekomiNewRouteImport } from './routes/_authenticated/admin/kakekomi/new'
import { Route as AuthenticatedAdminInquiriesNotificationsRouteImport } from './routes/_authenticated/admin/inquiries/notifications'
import { Route as AuthenticatedAdminInquiriesIdRouteImport } from './routes/_authenticated/admin/inquiries/$id'
import { Route as AuthenticatedAdminCasesIdRouteRouteImport } from './routes/_authenticated/admin/cases/$id/route'
import { Route as AuthenticatedMemberCompaniesIdIndexRouteImport } from './routes/_authenticated/member/companies/$id/index'
import { Route as AuthenticatedEnterpriseMembersIdIndexRouteImport } from './routes/_authenticated/enterprise/members/$id/index'
import { Route as AuthenticatedAdminOrganizationsIdIndexRouteImport } from './routes/_authenticated/admin/organizations/$id/index'
import { Route as AuthenticatedAdminKakekomiIdIndexRouteImport } from './routes/_authenticated/admin/kakekomi/$id/index'
import { Route as AuthenticatedAdminCasesIdIndexRouteImport } from './routes/_authenticated/admin/cases/$id/index'
import { Route as AuthenticatedEnterpriseIdApplicationsAppIdRouteImport } from './routes/_authenticated/enterprise/$id/applications/$appId'
import { Route as AuthenticatedAdminKakekomiIdEditRouteImport } from './routes/_authenticated/admin/kakekomi/$id/edit'
import { Route as AuthenticatedAdminCasesIdApplicationsAppIdRouteImport } from './routes/_authenticated/admin/cases/$id/applications/$appId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideRoute = GuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShowcaseIndexRoute = ShowcaseIndexRouteImport.update({
  id: '/showcase/',
  path: '/showcase/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShowcaseSlugRoute = ShowcaseSlugRouteImport.update({
  id: '/showcase/$slug',
  path: '/showcase/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyMemberRoute = ApplyMemberRouteImport.update({
  id: '/apply/member',
  path: '/apply/member',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplyEnterpriseRoute = ApplyEnterpriseRouteImport.update({
  id: '/apply/enterprise',
  path: '/apply/enterprise',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMemberRouteRoute =
  AuthenticatedMemberRouteRouteImport.update({
    id: '/member',
    path: '/member',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEnterpriseRouteRoute =
  AuthenticatedEnterpriseRouteRouteImport.update({
    id: '/enterprise',
    path: '/enterprise',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMemberIndexRoute =
  AuthenticatedMemberIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMemberRouteRoute,
  } as any)
const AuthenticatedEnterpriseIndexRoute =
  AuthenticatedEnterpriseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEnterpriseRouteRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedMemberSavedRoute =
  AuthenticatedMemberSavedRouteImport.update({
    id: '/saved',
    path: '/saved',
    getParentRoute: () => AuthenticatedMemberRouteRoute,
  } as any)
const AuthenticatedMemberPocEnvironmentRoute =
  AuthenticatedMemberPocEnvironmentRouteImport.update({
    id: '/poc-environment',
    path: '/poc-environment',
    getParentRoute: () => AuthenticatedMemberRouteRoute,
  } as any)
const AuthenticatedMemberMyApplicationsRoute =
  AuthenticatedMemberMyApplicationsRouteImport.update({
    id: '/my-applications',
    path: '/my-applications',
    getParentRoute: () => AuthenticatedMemberRouteRoute,
  } as any)
const AuthenticatedEnterprisePocEnvironmentRoute =
  AuthenticatedEnterprisePocEnvironmentRouteImport.update({
    id: '/poc-environment',
    path: '/poc-environment',
    getParentRoute: () => AuthenticatedEnterpriseRouteRoute,
  } as any)
const AuthenticatedEnterpriseNewRoute =
  AuthenticatedEnterpriseNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedEnterpriseRouteRoute,
  } as any)
const AuthenticatedAdminUsageRoute = AuthenticatedAdminUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedAdminMemberRegisterRoute =
  AuthenticatedAdminMemberRegisterRouteImport.update({
    id: '/member-register',
    path: '/member-register',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminEnterpriseRegisterRoute =
  AuthenticatedAdminEnterpriseRegisterRouteImport.update({
    id: '/enterprise-register',
    path: '/enterprise-register',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminAdminRegisterRoute =
  AuthenticatedAdminAdminRegisterRouteImport.update({
    id: '/admin-register',
    path: '/admin-register',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedMemberCompaniesRouteRoute =
  AuthenticatedMemberCompaniesRouteRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => AuthenticatedMemberRouteRoute,
  } as any)
const AuthenticatedMemberIdRouteRoute =
  AuthenticatedMemberIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedMemberRouteRoute,
  } as any)
const AuthenticatedEnterpriseIdRouteRoute =
  AuthenticatedEnterpriseIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedEnterpriseRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsRouteRoute =
  AuthenticatedAdminOrganizationsRouteRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCasesRouteRoute =
  AuthenticatedAdminCasesRouteRouteImport.update({
    id: '/cases',
    path: '/cases',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedMemberCompaniesIndexRoute =
  AuthenticatedMemberCompaniesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMemberCompaniesRouteRoute,
  } as any)
const AuthenticatedMemberIdIndexRoute =
  AuthenticatedMemberIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMemberIdRouteRoute,
  } as any)
const AuthenticatedEnterpriseApplicationsIndexRoute =
  AuthenticatedEnterpriseApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => AuthenticatedEnterpriseRouteRoute,
  } as any)
const AuthenticatedEnterpriseActiveIndexRoute =
  AuthenticatedEnterpriseActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => AuthenticatedEnterpriseRouteRoute,
  } as any)
const AuthenticatedEnterpriseIdIndexRoute =
  AuthenticatedEnterpriseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEnterpriseIdRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsIndexRoute =
  AuthenticatedAdminOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminOrganizationsRouteRoute,
  } as any)
const AuthenticatedAdminKakekomiIndexRoute =
  AuthenticatedAdminKakekomiIndexRouteImport.update({
    id: '/kakekomi/',
    path: '/kakekomi/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminInquiriesIndexRoute =
  AuthenticatedAdminInquiriesIndexRouteImport.update({
    id: '/inquiries/',
    path: '/inquiries/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCasesIndexRoute =
  AuthenticatedAdminCasesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminCasesRouteRoute,
  } as any)
const AuthenticatedAdminApplicationsIndexRoute =
  AuthenticatedAdminApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedMemberIdApplyRoute =
  AuthenticatedMemberIdApplyRouteImport.update({
    id: '/apply',
    path: '/apply',
    getParentRoute: () => AuthenticatedMemberIdRouteRoute,
  } as any)
const AuthenticatedEnterpriseIdEditRoute =
  AuthenticatedEnterpriseIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedEnterpriseIdRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsMembersRoute =
  AuthenticatedAdminOrganizationsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedAdminOrganizationsRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsCompaniesRoute =
  AuthenticatedAdminOrganizationsCompaniesRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => AuthenticatedAdminOrganizationsRouteRoute,
  } as any)
const AuthenticatedAdminKakekomiNewRoute =
  AuthenticatedAdminKakekomiNewRouteImport.update({
    id: '/kakekomi/new',
    path: '/kakekomi/new',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminInquiriesNotificationsRoute =
  AuthenticatedAdminInquiriesNotificationsRouteImport.update({
    id: '/inquiries/notifications',
    path: '/inquiries/notifications',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminInquiriesIdRoute =
  AuthenticatedAdminInquiriesIdRouteImport.update({
    id: '/inquiries/$id',
    path: '/inquiries/$id',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCasesIdRouteRoute =
  AuthenticatedAdminCasesIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedAdminCasesRouteRoute,
  } as any)
const AuthenticatedMemberCompaniesIdIndexRoute =
  AuthenticatedMemberCompaniesIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthenticatedMemberCompaniesRouteRoute,
  } as any)
const AuthenticatedEnterpriseMembersIdIndexRoute =
  AuthenticatedEnterpriseMembersIdIndexRouteImport.update({
    id: '/members/$id/',
    path: '/members/$id/',
    getParentRoute: () => AuthenticatedEnterpriseRouteRoute,
  } as any)
const AuthenticatedAdminOrganizationsIdIndexRoute =
  AuthenticatedAdminOrganizationsIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthenticatedAdminOrganizationsRouteRoute,
  } as any)
const AuthenticatedAdminKakekomiIdIndexRoute =
  AuthenticatedAdminKakekomiIdIndexRouteImport.update({
    id: '/kakekomi/$id/',
    path: '/kakekomi/$id/',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCasesIdIndexRoute =
  AuthenticatedAdminCasesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminCasesIdRouteRoute,
  } as any)
const AuthenticatedEnterpriseIdApplicationsAppIdRoute =
  AuthenticatedEnterpriseIdApplicationsAppIdRouteImport.update({
    id: '/applications/$appId',
    path: '/applications/$appId',
    getParentRoute: () => AuthenticatedEnterpriseIdRouteRoute,
  } as any)
const AuthenticatedAdminKakekomiIdEditRoute =
  AuthenticatedAdminKakekomiIdEditRouteImport.update({
    id: '/kakekomi/$id/edit',
    path: '/kakekomi/$id/edit',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminCasesIdApplicationsAppIdRoute =
  AuthenticatedAdminCasesIdApplicationsAppIdRouteImport.update({
    id: '/applications/$appId',
    path: '/applications/$appId',
    getParentRoute: () => AuthenticatedAdminCasesIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/guide': typeof GuideRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/enterprise': typeof AuthenticatedEnterpriseRouteRouteWithChildren
  '/member': typeof AuthenticatedMemberRouteRouteWithChildren
  '/profile': typeof AuthenticatedProfileRoute
  '/apply/enterprise': typeof ApplyEnterpriseRoute
  '/apply/member': typeof ApplyMemberRoute
  '/showcase/$slug': typeof ShowcaseSlugRoute
  '/showcase/': typeof ShowcaseIndexRoute
  '/admin/cases': typeof AuthenticatedAdminCasesRouteRouteWithChildren
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsRouteRouteWithChildren
  '/enterprise/$id': typeof AuthenticatedEnterpriseIdRouteRouteWithChildren
  '/member/$id': typeof AuthenticatedMemberIdRouteRouteWithChildren
  '/member/companies': typeof AuthenticatedMemberCompaniesRouteRouteWithChildren
  '/admin/admin-register': typeof AuthenticatedAdminAdminRegisterRoute
  '/admin/enterprise-register': typeof AuthenticatedAdminEnterpriseRegisterRoute
  '/admin/member-register': typeof AuthenticatedAdminMemberRegisterRoute
  '/admin/usage': typeof AuthenticatedAdminUsageRoute
  '/enterprise/new': typeof AuthenticatedEnterpriseNewRoute
  '/enterprise/poc-environment': typeof AuthenticatedEnterprisePocEnvironmentRoute
  '/member/my-applications': typeof AuthenticatedMemberMyApplicationsRoute
  '/member/poc-environment': typeof AuthenticatedMemberPocEnvironmentRoute
  '/member/saved': typeof AuthenticatedMemberSavedRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/enterprise/': typeof AuthenticatedEnterpriseIndexRoute
  '/member/': typeof AuthenticatedMemberIndexRoute
  '/admin/cases/$id': typeof AuthenticatedAdminCasesIdRouteRouteWithChildren
  '/admin/inquiries/$id': typeof AuthenticatedAdminInquiriesIdRoute
  '/admin/inquiries/notifications': typeof AuthenticatedAdminInquiriesNotificationsRoute
  '/admin/kakekomi/new': typeof AuthenticatedAdminKakekomiNewRoute
  '/admin/organizations/companies': typeof AuthenticatedAdminOrganizationsCompaniesRoute
  '/admin/organizations/members': typeof AuthenticatedAdminOrganizationsMembersRoute
  '/enterprise/$id/edit': typeof AuthenticatedEnterpriseIdEditRoute
  '/member/$id/apply': typeof AuthenticatedMemberIdApplyRoute
  '/admin/applications/': typeof AuthenticatedAdminApplicationsIndexRoute
  '/admin/cases/': typeof AuthenticatedAdminCasesIndexRoute
  '/admin/inquiries/': typeof AuthenticatedAdminInquiriesIndexRoute
  '/admin/kakekomi/': typeof AuthenticatedAdminKakekomiIndexRoute
  '/admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/enterprise/$id/': typeof AuthenticatedEnterpriseIdIndexRoute
  '/enterprise/active/': typeof AuthenticatedEnterpriseActiveIndexRoute
  '/enterprise/applications/': typeof AuthenticatedEnterpriseApplicationsIndexRoute
  '/member/$id/': typeof AuthenticatedMemberIdIndexRoute
  '/member/companies/': typeof AuthenticatedMemberCompaniesIndexRoute
  '/admin/kakekomi/$id/edit': typeof AuthenticatedAdminKakekomiIdEditRoute
  '/enterprise/$id/applications/$appId': typeof AuthenticatedEnterpriseIdApplicationsAppIdRoute
  '/admin/cases/$id/': typeof AuthenticatedAdminCasesIdIndexRoute
  '/admin/kakekomi/$id/': typeof AuthenticatedAdminKakekomiIdIndexRoute
  '/admin/organizations/$id/': typeof AuthenticatedAdminOrganizationsIdIndexRoute
  '/enterprise/members/$id/': typeof AuthenticatedEnterpriseMembersIdIndexRoute
  '/member/companies/$id/': typeof AuthenticatedMemberCompaniesIdIndexRoute
  '/admin/cases/$id/applications/$appId': typeof AuthenticatedAdminCasesIdApplicationsAppIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/guide': typeof GuideRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/apply/enterprise': typeof ApplyEnterpriseRoute
  '/apply/member': typeof ApplyMemberRoute
  '/showcase/$slug': typeof ShowcaseSlugRoute
  '/showcase': typeof ShowcaseIndexRoute
  '/admin/admin-register': typeof AuthenticatedAdminAdminRegisterRoute
  '/admin/enterprise-register': typeof AuthenticatedAdminEnterpriseRegisterRoute
  '/admin/member-register': typeof AuthenticatedAdminMemberRegisterRoute
  '/admin/usage': typeof AuthenticatedAdminUsageRoute
  '/enterprise/new': typeof AuthenticatedEnterpriseNewRoute
  '/enterprise/poc-environment': typeof AuthenticatedEnterprisePocEnvironmentRoute
  '/member/my-applications': typeof AuthenticatedMemberMyApplicationsRoute
  '/member/poc-environment': typeof AuthenticatedMemberPocEnvironmentRoute
  '/member/saved': typeof AuthenticatedMemberSavedRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/enterprise': typeof AuthenticatedEnterpriseIndexRoute
  '/member': typeof AuthenticatedMemberIndexRoute
  '/admin/inquiries/$id': typeof AuthenticatedAdminInquiriesIdRoute
  '/admin/inquiries/notifications': typeof AuthenticatedAdminInquiriesNotificationsRoute
  '/admin/kakekomi/new': typeof AuthenticatedAdminKakekomiNewRoute
  '/admin/organizations/companies': typeof AuthenticatedAdminOrganizationsCompaniesRoute
  '/admin/organizations/members': typeof AuthenticatedAdminOrganizationsMembersRoute
  '/enterprise/$id/edit': typeof AuthenticatedEnterpriseIdEditRoute
  '/member/$id/apply': typeof AuthenticatedMemberIdApplyRoute
  '/admin/applications': typeof AuthenticatedAdminApplicationsIndexRoute
  '/admin/cases': typeof AuthenticatedAdminCasesIndexRoute
  '/admin/inquiries': typeof AuthenticatedAdminInquiriesIndexRoute
  '/admin/kakekomi': typeof AuthenticatedAdminKakekomiIndexRoute
  '/admin/organizations': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/enterprise/$id': typeof AuthenticatedEnterpriseIdIndexRoute
  '/enterprise/active': typeof AuthenticatedEnterpriseActiveIndexRoute
  '/enterprise/applications': typeof AuthenticatedEnterpriseApplicationsIndexRoute
  '/member/$id': typeof AuthenticatedMemberIdIndexRoute
  '/member/companies': typeof AuthenticatedMemberCompaniesIndexRoute
  '/admin/kakekomi/$id/edit': typeof AuthenticatedAdminKakekomiIdEditRoute
  '/enterprise/$id/applications/$appId': typeof AuthenticatedEnterpriseIdApplicationsAppIdRoute
  '/admin/cases/$id': typeof AuthenticatedAdminCasesIdIndexRoute
  '/admin/kakekomi/$id': typeof AuthenticatedAdminKakekomiIdIndexRoute
  '/admin/organizations/$id': typeof AuthenticatedAdminOrganizationsIdIndexRoute
  '/enterprise/members/$id': typeof AuthenticatedEnterpriseMembersIdIndexRoute
  '/member/companies/$id': typeof AuthenticatedMemberCompaniesIdIndexRoute
  '/admin/cases/$id/applications/$appId': typeof AuthenticatedAdminCasesIdApplicationsAppIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/guide': typeof GuideRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/enterprise': typeof AuthenticatedEnterpriseRouteRouteWithChildren
  '/_authenticated/member': typeof AuthenticatedMemberRouteRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/apply/enterprise': typeof ApplyEnterpriseRoute
  '/apply/member': typeof ApplyMemberRoute
  '/showcase/$slug': typeof ShowcaseSlugRoute
  '/showcase/': typeof ShowcaseIndexRoute
  '/_authenticated/admin/cases': typeof AuthenticatedAdminCasesRouteRouteWithChildren
  '/_authenticated/admin/organizations': typeof AuthenticatedAdminOrganizationsRouteRouteWithChildren
  '/_authenticated/enterprise/$id': typeof AuthenticatedEnterpriseIdRouteRouteWithChildren
  '/_authenticated/member/$id': typeof AuthenticatedMemberIdRouteRouteWithChildren
  '/_authenticated/member/companies': typeof AuthenticatedMemberCompaniesRouteRouteWithChildren
  '/_authenticated/admin/admin-register': typeof AuthenticatedAdminAdminRegisterRoute
  '/_authenticated/admin/enterprise-register': typeof AuthenticatedAdminEnterpriseRegisterRoute
  '/_authenticated/admin/member-register': typeof AuthenticatedAdminMemberRegisterRoute
  '/_authenticated/admin/usage': typeof AuthenticatedAdminUsageRoute
  '/_authenticated/enterprise/new': typeof AuthenticatedEnterpriseNewRoute
  '/_authenticated/enterprise/poc-environment': typeof AuthenticatedEnterprisePocEnvironmentRoute
  '/_authenticated/member/my-applications': typeof AuthenticatedMemberMyApplicationsRoute
  '/_authenticated/member/poc-environment': typeof AuthenticatedMemberPocEnvironmentRoute
  '/_authenticated/member/saved': typeof AuthenticatedMemberSavedRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/enterprise/': typeof AuthenticatedEnterpriseIndexRoute
  '/_authenticated/member/': typeof AuthenticatedMemberIndexRoute
  '/_authenticated/admin/cases/$id': typeof AuthenticatedAdminCasesIdRouteRouteWithChildren
  '/_authenticated/admin/inquiries/$id': typeof AuthenticatedAdminInquiriesIdRoute
  '/_authenticated/admin/inquiries/notifications': typeof AuthenticatedAdminInquiriesNotificationsRoute
  '/_authenticated/admin/kakekomi/new': typeof AuthenticatedAdminKakekomiNewRoute
  '/_authenticated/admin/organizations/companies': typeof AuthenticatedAdminOrganizationsCompaniesRoute
  '/_authenticated/admin/organizations/members': typeof AuthenticatedAdminOrganizationsMembersRoute
  '/_authenticated/enterprise/$id/edit': typeof AuthenticatedEnterpriseIdEditRoute
  '/_authenticated/member/$id/apply': typeof AuthenticatedMemberIdApplyRoute
  '/_authenticated/admin/applications/': typeof AuthenticatedAdminApplicationsIndexRoute
  '/_authenticated/admin/cases/': typeof AuthenticatedAdminCasesIndexRoute
  '/_authenticated/admin/inquiries/': typeof AuthenticatedAdminInquiriesIndexRoute
  '/_authenticated/admin/kakekomi/': typeof AuthenticatedAdminKakekomiIndexRoute
  '/_authenticated/admin/organizations/': typeof AuthenticatedAdminOrganizationsIndexRoute
  '/_authenticated/enterprise/$id/': typeof AuthenticatedEnterpriseIdIndexRoute
  '/_authenticated/enterprise/active/': typeof AuthenticatedEnterpriseActiveIndexRoute
  '/_authenticated/enterprise/applications/': typeof AuthenticatedEnterpriseApplicationsIndexRoute
  '/_authenticated/member/$id/': typeof AuthenticatedMemberIdIndexRoute
  '/_authenticated/member/companies/': typeof AuthenticatedMemberCompaniesIndexRoute
  '/_authenticated/admin/kakekomi/$id/edit': typeof AuthenticatedAdminKakekomiIdEditRoute
  '/_authenticated/enterprise/$id/applications/$appId': typeof AuthenticatedEnterpriseIdApplicationsAppIdRoute
  '/_authenticated/admin/cases/$id/': typeof AuthenticatedAdminCasesIdIndexRoute
  '/_authenticated/admin/kakekomi/$id/': typeof AuthenticatedAdminKakekomiIdIndexRoute
  '/_authenticated/admin/organizations/$id/': typeof AuthenticatedAdminOrganizationsIdIndexRoute
  '/_authenticated/enterprise/members/$id/': typeof AuthenticatedEnterpriseMembersIdIndexRoute
  '/_authenticated/member/companies/$id/': typeof AuthenticatedMemberCompaniesIdIndexRoute
  '/_authenticated/admin/cases/$id/applications/$appId': typeof AuthenticatedAdminCasesIdApplicationsAppIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/guide'
    | '/privacy'
    | '/reset-password'
    | '/terms'
    | '/admin'
    | '/enterprise'
    | '/member'
    | '/profile'
    | '/apply/enterprise'
    | '/apply/member'
    | '/showcase/$slug'
    | '/showcase/'
    | '/admin/cases'
    | '/admin/organizations'
    | '/enterprise/$id'
    | '/member/$id'
    | '/member/companies'
    | '/admin/admin-register'
    | '/admin/enterprise-register'
    | '/admin/member-register'
    | '/admin/usage'
    | '/enterprise/new'
    | '/enterprise/poc-environment'
    | '/member/my-applications'
    | '/member/poc-environment'
    | '/member/saved'
    | '/admin/'
    | '/enterprise/'
    | '/member/'
    | '/admin/cases/$id'
    | '/admin/inquiries/$id'
    | '/admin/inquiries/notifications'
    | '/admin/kakekomi/new'
    | '/admin/organizations/companies'
    | '/admin/organizations/members'
    | '/enterprise/$id/edit'
    | '/member/$id/apply'
    | '/admin/applications/'
    | '/admin/cases/'
    | '/admin/inquiries/'
    | '/admin/kakekomi/'
    | '/admin/organizations/'
    | '/enterprise/$id/'
    | '/enterprise/active/'
    | '/enterprise/applications/'
    | '/member/$id/'
    | '/member/companies/'
    | '/admin/kakekomi/$id/edit'
    | '/enterprise/$id/applications/$appId'
    | '/admin/cases/$id/'
    | '/admin/kakekomi/$id/'
    | '/admin/organizations/$id/'
    | '/enterprise/members/$id/'
    | '/member/companies/$id/'
    | '/admin/cases/$id/applications/$appId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/guide'
    | '/privacy'
    | '/reset-password'
    | '/terms'
    | '/profile'
    | '/apply/enterprise'
    | '/apply/member'
    | '/showcase/$slug'
    | '/showcase'
    | '/admin/admin-register'
    | '/admin/enterprise-register'
    | '/admin/member-register'
    | '/admin/usage'
    | '/enterprise/new'
    | '/enterprise/poc-environment'
    | '/member/my-applications'
    | '/member/poc-environment'
    | '/member/saved'
    | '/admin'
    | '/enterprise'
    | '/member'
    | '/admin/inquiries/$id'
    | '/admin/inquiries/notifications'
    | '/admin/kakekomi/new'
    | '/admin/organizations/companies'
    | '/admin/organizations/members'
    | '/enterprise/$id/edit'
    | '/member/$id/apply'
    | '/admin/applications'
    | '/admin/cases'
    | '/admin/inquiries'
    | '/admin/kakekomi'
    | '/admin/organizations'
    | '/enterprise/$id'
    | '/enterprise/active'
    | '/enterprise/applications'
    | '/member/$id'
    | '/member/companies'
    | '/admin/kakekomi/$id/edit'
    | '/enterprise/$id/applications/$appId'
    | '/admin/cases/$id'
    | '/admin/kakekomi/$id'
    | '/admin/organizations/$id'
    | '/enterprise/members/$id'
    | '/member/companies/$id'
    | '/admin/cases/$id/applications/$appId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/guide'
    | '/privacy'
    | '/reset-password'
    | '/terms'
    | '/_authenticated/admin'
    | '/_authenticated/enterprise'
    | '/_authenticated/member'
    | '/_authenticated/profile'
    | '/apply/enterprise'
    | '/apply/member'
    | '/showcase/$slug'
    | '/showcase/'
    | '/_authenticated/admin/cases'
    | '/_authenticated/admin/organizations'
    | '/_authenticated/enterprise/$id'
    | '/_authenticated/member/$id'
    | '/_authenticated/member/companies'
    | '/_authenticated/admin/admin-register'
    | '/_authenticated/admin/enterprise-register'
    | '/_authenticated/admin/member-register'
    | '/_authenticated/admin/usage'
    | '/_authenticated/enterprise/new'
    | '/_authenticated/enterprise/poc-environment'
    | '/_authenticated/member/my-applications'
    | '/_authenticated/member/poc-environment'
    | '/_authenticated/member/saved'
    | '/_authenticated/admin/'
    | '/_authenticated/enterprise/'
    | '/_authenticated/member/'
    | '/_authenticated/admin/cases/$id'
    | '/_authenticated/admin/inquiries/$id'
    | '/_authenticated/admin/inquiries/notifications'
    | '/_authenticated/admin/kakekomi/new'
    | '/_authenticated/admin/organizations/companies'
    | '/_authenticated/admin/organizations/members'
    | '/_authenticated/enterprise/$id/edit'
    | '/_authenticated/member/$id/apply'
    | '/_authenticated/admin/applications/'
    | '/_authenticated/admin/cases/'
    | '/_authenticated/admin/inquiries/'
    | '/_authenticated/admin/kakekomi/'
    | '/_authenticated/admin/organizations/'
    | '/_authenticated/enterprise/$id/'
    | '/_authenticated/enterprise/active/'
    | '/_authenticated/enterprise/applications/'
    | '/_authenticated/member/$id/'
    | '/_authenticated/member/companies/'
    | '/_authenticated/admin/kakekomi/$id/edit'
    | '/_authenticated/enterprise/$id/applications/$appId'
    | '/_authenticated/admin/cases/$id/'
    | '/_authenticated/admin/kakekomi/$id/'
    | '/_authenticated/admin/organizations/$id/'
    | '/_authenticated/enterprise/members/$id/'
    | '/_authenticated/member/companies/$id/'
    | '/_authenticated/admin/cases/$id/applications/$appId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GuideRoute: typeof GuideRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TermsRoute: typeof TermsRoute
  ApplyEnterpriseRoute: typeof ApplyEnterpriseRoute
  ApplyMemberRoute: typeof ApplyMemberRoute
  ShowcaseSlugRoute: typeof ShowcaseSlugRoute
  ShowcaseIndexRoute: typeof ShowcaseIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide': {
      id: '/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof GuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/showcase/': {
      id: '/showcase/'
      path: '/showcase'
      fullPath: '/showcase/'
      preLoaderRoute: typeof ShowcaseIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/showcase/$slug': {
      id: '/showcase/$slug'
      path: '/showcase/$slug'
      fullPath: '/showcase/$slug'
      preLoaderRoute: typeof ShowcaseSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/member': {
      id: '/apply/member'
      path: '/apply/member'
      fullPath: '/apply/member'
      preLoaderRoute: typeof ApplyMemberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apply/enterprise': {
      id: '/apply/enterprise'
      path: '/apply/enterprise'
      fullPath: '/apply/enterprise'
      preLoaderRoute: typeof ApplyEnterpriseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/member': {
      id: '/_authenticated/member'
      path: '/member'
      fullPath: '/member'
      preLoaderRoute: typeof AuthenticatedMemberRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/enterprise': {
      id: '/_authenticated/enterprise'
      path: '/enterprise'
      fullPath: '/enterprise'
      preLoaderRoute: typeof AuthenticatedEnterpriseRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/member/': {
      id: '/_authenticated/member/'
      path: '/'
      fullPath: '/member/'
      preLoaderRoute: typeof AuthenticatedMemberIndexRouteImport
      parentRoute: typeof AuthenticatedMemberRouteRoute
    }
    '/_authenticated/enterprise/': {
      id: '/_authenticated/enterprise/'
      path: '/'
      fullPath: '/enterprise/'
      preLoaderRoute: typeof AuthenticatedEnterpriseIndexRouteImport
      parentRoute: typeof AuthenticatedEnterpriseRouteRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/member/saved': {
      id: '/_authenticated/member/saved'
      path: '/saved'
      fullPath: '/member/saved'
      preLoaderRoute: typeof AuthenticatedMemberSavedRouteImport
      parentRoute: typeof AuthenticatedMemberRouteRoute
    }
    '/_authenticated/member/poc-environment': {
      id: '/_authenticated/member/poc-environment'
      path: '/poc-environment'
      fullPath: '/member/poc-environment'
      preLoaderRoute: typeof AuthenticatedMemberPocEnvironmentRouteImport
      parentRoute: typeof AuthenticatedMemberRouteRoute
    }
    '/_authenticated/member/my-applications': {
      id: '/_authenticated/member/my-applications'
      path: '/my-applications'
      fullPath: '/member/my-applications'
      preLoaderRoute: typeof AuthenticatedMemberMyApplicationsRouteImport
      parentRoute: typeof AuthenticatedMemberRouteRoute
    }
    '/_authenticated/enterprise/poc-environment': {
      id: '/_authenticated/enterprise/poc-environment'
      path: '/poc-environment'
      fullPath: '/enterprise/poc-environment'
      preLoaderRoute: typeof AuthenticatedEnterprisePocEnvironmentRouteImport
      parentRoute: typeof AuthenticatedEnterpriseRouteRoute
    }
    '/_authenticated/enterprise/new': {
      id: '/_authenticated/enterprise/new'
      path: '/new'
      fullPath: '/enterprise/new'
      preLoaderRoute: typeof AuthenticatedEnterpriseNewRouteImport
      parentRoute: typeof AuthenticatedEnterpriseRouteRoute
    }
    '/_authenticated/admin/usage': {
      id: '/_authenticated/admin/usage'
      path: '/usage'
      fullPath: '/admin/usage'
      preLoaderRoute: typeof AuthenticatedAdminUsageRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/member-register': {
      id: '/_authenticated/admin/member-register'
      path: '/member-register'
      fullPath: '/admin/member-register'
      preLoaderRoute: typeof AuthenticatedAdminMemberRegisterRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/enterprise-register': {
      id: '/_authenticated/admin/enterprise-register'
      path: '/enterprise-register'
      fullPath: '/admin/enterprise-register'
      preLoaderRoute: typeof AuthenticatedAdminEnterpriseRegisterRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/admin-register': {
      id: '/_authenticated/admin/admin-register'
      path: '/admin-register'
      fullPath: '/admin/admin-register'
      preLoaderRoute: typeof AuthenticatedAdminAdminRegisterRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/member/companies': {
      id: '/_authenticated/member/companies'
      path: '/companies'
      fullPath: '/member/companies'
      preLoaderRoute: typeof AuthenticatedMemberCompaniesRouteRouteImport
      parentRoute: typeof AuthenticatedMemberRouteRoute
    }
    '/_authenticated/member/$id': {
      id: '/_authenticated/member/$id'
      path: '/$id'
      fullPath: '/member/$id'
      preLoaderRoute: typeof AuthenticatedMemberIdRouteRouteImport
      parentRoute: typeof AuthenticatedMemberRouteRoute
    }
    '/_authenticated/enterprise/$id': {
      id: '/_authenticated/enterprise/$id'
      path: '/$id'
      fullPath: '/enterprise/$id'
      preLoaderRoute: typeof AuthenticatedEnterpriseIdRouteRouteImport
      parentRoute: typeof AuthenticatedEnterpriseRouteRoute
    }
    '/_authenticated/admin/organizations': {
      id: '/_authenticated/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsRouteRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/cases': {
      id: '/_authenticated/admin/cases'
      path: '/cases'
      fullPath: '/admin/cases'
      preLoaderRoute: typeof AuthenticatedAdminCasesRouteRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/member/companies/': {
      id: '/_authenticated/member/companies/'
      path: '/'
      fullPath: '/member/companies/'
      preLoaderRoute: typeof AuthenticatedMemberCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedMemberCompaniesRouteRoute
    }
    '/_authenticated/member/$id/': {
      id: '/_authenticated/member/$id/'
      path: '/'
      fullPath: '/member/$id/'
      preLoaderRoute: typeof AuthenticatedMemberIdIndexRouteImport
      parentRoute: typeof AuthenticatedMemberIdRouteRoute
    }
    '/_authenticated/enterprise/applications/': {
      id: '/_authenticated/enterprise/applications/'
      path: '/applications'
      fullPath: '/enterprise/applications/'
      preLoaderRoute: typeof AuthenticatedEnterpriseApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedEnterpriseRouteRoute
    }
    '/_authenticated/enterprise/active/': {
      id: '/_authenticated/enterprise/active/'
      path: '/active'
      fullPath: '/enterprise/active/'
      preLoaderRoute: typeof AuthenticatedEnterpriseActiveIndexRouteImport
      parentRoute: typeof AuthenticatedEnterpriseRouteRoute
    }
    '/_authenticated/enterprise/$id/': {
      id: '/_authenticated/enterprise/$id/'
      path: '/'
      fullPath: '/enterprise/$id/'
      preLoaderRoute: typeof AuthenticatedEnterpriseIdIndexRouteImport
      parentRoute: typeof AuthenticatedEnterpriseIdRouteRoute
    }
    '/_authenticated/admin/organizations/': {
      id: '/_authenticated/admin/organizations/'
      path: '/'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsRouteRoute
    }
    '/_authenticated/admin/kakekomi/': {
      id: '/_authenticated/admin/kakekomi/'
      path: '/kakekomi'
      fullPath: '/admin/kakekomi/'
      preLoaderRoute: typeof AuthenticatedAdminKakekomiIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/inquiries/': {
      id: '/_authenticated/admin/inquiries/'
      path: '/inquiries'
      fullPath: '/admin/inquiries/'
      preLoaderRoute: typeof AuthenticatedAdminInquiriesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/cases/': {
      id: '/_authenticated/admin/cases/'
      path: '/'
      fullPath: '/admin/cases/'
      preLoaderRoute: typeof AuthenticatedAdminCasesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminCasesRouteRoute
    }
    '/_authenticated/admin/applications/': {
      id: '/_authenticated/admin/applications/'
      path: '/applications'
      fullPath: '/admin/applications/'
      preLoaderRoute: typeof AuthenticatedAdminApplicationsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/member/$id/apply': {
      id: '/_authenticated/member/$id/apply'
      path: '/apply'
      fullPath: '/member/$id/apply'
      preLoaderRoute: typeof AuthenticatedMemberIdApplyRouteImport
      parentRoute: typeof AuthenticatedMemberIdRouteRoute
    }
    '/_authenticated/enterprise/$id/edit': {
      id: '/_authenticated/enterprise/$id/edit'
      path: '/edit'
      fullPath: '/enterprise/$id/edit'
      preLoaderRoute: typeof AuthenticatedEnterpriseIdEditRouteImport
      parentRoute: typeof AuthenticatedEnterpriseIdRouteRoute
    }
    '/_authenticated/admin/organizations/members': {
      id: '/_authenticated/admin/organizations/members'
      path: '/members'
      fullPath: '/admin/organizations/members'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsMembersRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsRouteRoute
    }
    '/_authenticated/admin/organizations/companies': {
      id: '/_authenticated/admin/organizations/companies'
      path: '/companies'
      fullPath: '/admin/organizations/companies'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsCompaniesRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsRouteRoute
    }
    '/_authenticated/admin/kakekomi/new': {
      id: '/_authenticated/admin/kakekomi/new'
      path: '/kakekomi/new'
      fullPath: '/admin/kakekomi/new'
      preLoaderRoute: typeof AuthenticatedAdminKakekomiNewRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/inquiries/notifications': {
      id: '/_authenticated/admin/inquiries/notifications'
      path: '/inquiries/notifications'
      fullPath: '/admin/inquiries/notifications'
      preLoaderRoute: typeof AuthenticatedAdminInquiriesNotificationsRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/inquiries/$id': {
      id: '/_authenticated/admin/inquiries/$id'
      path: '/inquiries/$id'
      fullPath: '/admin/inquiries/$id'
      preLoaderRoute: typeof AuthenticatedAdminInquiriesIdRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/cases/$id': {
      id: '/_authenticated/admin/cases/$id'
      path: '/$id'
      fullPath: '/admin/cases/$id'
      preLoaderRoute: typeof AuthenticatedAdminCasesIdRouteRouteImport
      parentRoute: typeof AuthenticatedAdminCasesRouteRoute
    }
    '/_authenticated/member/companies/$id/': {
      id: '/_authenticated/member/companies/$id/'
      path: '/$id'
      fullPath: '/member/companies/$id/'
      preLoaderRoute: typeof AuthenticatedMemberCompaniesIdIndexRouteImport
      parentRoute: typeof AuthenticatedMemberCompaniesRouteRoute
    }
    '/_authenticated/enterprise/members/$id/': {
      id: '/_authenticated/enterprise/members/$id/'
      path: '/members/$id'
      fullPath: '/enterprise/members/$id/'
      preLoaderRoute: typeof AuthenticatedEnterpriseMembersIdIndexRouteImport
      parentRoute: typeof AuthenticatedEnterpriseRouteRoute
    }
    '/_authenticated/admin/organizations/$id/': {
      id: '/_authenticated/admin/organizations/$id/'
      path: '/$id'
      fullPath: '/admin/organizations/$id/'
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminOrganizationsRouteRoute
    }
    '/_authenticated/admin/kakekomi/$id/': {
      id: '/_authenticated/admin/kakekomi/$id/'
      path: '/kakekomi/$id'
      fullPath: '/admin/kakekomi/$id/'
      preLoaderRoute: typeof AuthenticatedAdminKakekomiIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/cases/$id/': {
      id: '/_authenticated/admin/cases/$id/'
      path: '/'
      fullPath: '/admin/cases/$id/'
      preLoaderRoute: typeof AuthenticatedAdminCasesIdIndexRouteImport
      parentRoute: typeof AuthenticatedAdminCasesIdRouteRoute
    }
    '/_authenticated/enterprise/$id/applications/$appId': {
      id: '/_authenticated/enterprise/$id/applications/$appId'
      path: '/applications/$appId'
      fullPath: '/enterprise/$id/applications/$appId'
      preLoaderRoute: typeof AuthenticatedEnterpriseIdApplicationsAppIdRouteImport
      parentRoute: typeof AuthenticatedEnterpriseIdRouteRoute
    }
    '/_authenticated/admin/kakekomi/$id/edit': {
      id: '/_authenticated/admin/kakekomi/$id/edit'
      path: '/kakekomi/$id/edit'
      fullPath: '/admin/kakekomi/$id/edit'
      preLoaderRoute: typeof AuthenticatedAdminKakekomiIdEditRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/cases/$id/applications/$appId': {
      id: '/_authenticated/admin/cases/$id/applications/$appId'
      path: '/applications/$appId'
      fullPath: '/admin/cases/$id/applications/$appId'
      preLoaderRoute: typeof AuthenticatedAdminCasesIdApplicationsAppIdRouteImport
      parentRoute: typeof AuthenticatedAdminCasesIdRouteRoute
    }
  }
}

interface AuthenticatedAdminCasesIdRouteRouteChildren {
  AuthenticatedAdminCasesIdIndexRoute: typeof AuthenticatedAdminCasesIdIndexRoute
  AuthenticatedAdminCasesIdApplicationsAppIdRoute: typeof AuthenticatedAdminCasesIdApplicationsAppIdRoute
}

const AuthenticatedAdminCasesIdRouteRouteChildren: AuthenticatedAdminCasesIdRouteRouteChildren =
  {
    AuthenticatedAdminCasesIdIndexRoute: AuthenticatedAdminCasesIdIndexRoute,
    AuthenticatedAdminCasesIdApplicationsAppIdRoute:
      AuthenticatedAdminCasesIdApplicationsAppIdRoute,
  }

const AuthenticatedAdminCasesIdRouteRouteWithChildren =
  AuthenticatedAdminCasesIdRouteRoute._addFileChildren(
    AuthenticatedAdminCasesIdRouteRouteChildren,
  )

interface AuthenticatedAdminCasesRouteRouteChildren {
  AuthenticatedAdminCasesIdRouteRoute: typeof AuthenticatedAdminCasesIdRouteRouteWithChildren
  AuthenticatedAdminCasesIndexRoute: typeof AuthenticatedAdminCasesIndexRoute
}

const AuthenticatedAdminCasesRouteRouteChildren: AuthenticatedAdminCasesRouteRouteChildren =
  {
    AuthenticatedAdminCasesIdRouteRoute:
      AuthenticatedAdminCasesIdRouteRouteWithChildren,
    AuthenticatedAdminCasesIndexRoute: AuthenticatedAdminCasesIndexRoute,
  }

const AuthenticatedAdminCasesRouteRouteWithChildren =
  AuthenticatedAdminCasesRouteRoute._addFileChildren(
    AuthenticatedAdminCasesRouteRouteChildren,
  )

interface AuthenticatedAdminOrganizationsRouteRouteChildren {
  AuthenticatedAdminOrganizationsCompaniesRoute: typeof AuthenticatedAdminOrganizationsCompaniesRoute
  AuthenticatedAdminOrganizationsMembersRoute: typeof AuthenticatedAdminOrganizationsMembersRoute
  AuthenticatedAdminOrganizationsIndexRoute: typeof AuthenticatedAdminOrganizationsIndexRoute
  AuthenticatedAdminOrganizationsIdIndexRoute: typeof AuthenticatedAdminOrganizationsIdIndexRoute
}

const AuthenticatedAdminOrganizationsRouteRouteChildren: AuthenticatedAdminOrganizationsRouteRouteChildren =
  {
    AuthenticatedAdminOrganizationsCompaniesRoute:
      AuthenticatedAdminOrganizationsCompaniesRoute,
    AuthenticatedAdminOrganizationsMembersRoute:
      AuthenticatedAdminOrganizationsMembersRoute,
    AuthenticatedAdminOrganizationsIndexRoute:
      AuthenticatedAdminOrganizationsIndexRoute,
    AuthenticatedAdminOrganizationsIdIndexRoute:
      AuthenticatedAdminOrganizationsIdIndexRoute,
  }

const AuthenticatedAdminOrganizationsRouteRouteWithChildren =
  AuthenticatedAdminOrganizationsRouteRoute._addFileChildren(
    AuthenticatedAdminOrganizationsRouteRouteChildren,
  )

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminCasesRouteRoute: typeof AuthenticatedAdminCasesRouteRouteWithChildren
  AuthenticatedAdminOrganizationsRouteRoute: typeof AuthenticatedAdminOrganizationsRouteRouteWithChildren
  AuthenticatedAdminAdminRegisterRoute: typeof AuthenticatedAdminAdminRegisterRoute
  AuthenticatedAdminEnterpriseRegisterRoute: typeof AuthenticatedAdminEnterpriseRegisterRoute
  AuthenticatedAdminMemberRegisterRoute: typeof AuthenticatedAdminMemberRegisterRoute
  AuthenticatedAdminUsageRoute: typeof AuthenticatedAdminUsageRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminInquiriesIdRoute: typeof AuthenticatedAdminInquiriesIdRoute
  AuthenticatedAdminInquiriesNotificationsRoute: typeof AuthenticatedAdminInquiriesNotificationsRoute
  AuthenticatedAdminKakekomiNewRoute: typeof AuthenticatedAdminKakekomiNewRoute
  AuthenticatedAdminApplicationsIndexRoute: typeof AuthenticatedAdminApplicationsIndexRoute
  AuthenticatedAdminInquiriesIndexRoute: typeof AuthenticatedAdminInquiriesIndexRoute
  AuthenticatedAdminKakekomiIndexRoute: typeof AuthenticatedAdminKakekomiIndexRoute
  AuthenticatedAdminKakekomiIdEditRoute: typeof AuthenticatedAdminKakekomiIdEditRoute
  AuthenticatedAdminKakekomiIdIndexRoute: typeof AuthenticatedAdminKakekomiIdIndexRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminCasesRouteRoute:
      AuthenticatedAdminCasesRouteRouteWithChildren,
    AuthenticatedAdminOrganizationsRouteRoute:
      AuthenticatedAdminOrganizationsRouteRouteWithChildren,
    AuthenticatedAdminAdminRegisterRoute: AuthenticatedAdminAdminRegisterRoute,
    AuthenticatedAdminEnterpriseRegisterRoute:
      AuthenticatedAdminEnterpriseRegisterRoute,
    AuthenticatedAdminMemberRegisterRoute:
      AuthenticatedAdminMemberRegisterRoute,
    AuthenticatedAdminUsageRoute: AuthenticatedAdminUsageRoute,
    AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
    AuthenticatedAdminInquiriesIdRoute: AuthenticatedAdminInquiriesIdRoute,
    AuthenticatedAdminInquiriesNotificationsRoute:
      AuthenticatedAdminInquiriesNotificationsRoute,
    AuthenticatedAdminKakekomiNewRoute: AuthenticatedAdminKakekomiNewRoute,
    AuthenticatedAdminApplicationsIndexRoute:
      AuthenticatedAdminApplicationsIndexRoute,
    AuthenticatedAdminInquiriesIndexRoute:
      AuthenticatedAdminInquiriesIndexRoute,
    AuthenticatedAdminKakekomiIndexRoute: AuthenticatedAdminKakekomiIndexRoute,
    AuthenticatedAdminKakekomiIdEditRoute:
      AuthenticatedAdminKakekomiIdEditRoute,
    AuthenticatedAdminKakekomiIdIndexRoute:
      AuthenticatedAdminKakekomiIdIndexRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedEnterpriseIdRouteRouteChildren {
  AuthenticatedEnterpriseIdEditRoute: typeof AuthenticatedEnterpriseIdEditRoute
  AuthenticatedEnterpriseIdIndexRoute: typeof AuthenticatedEnterpriseIdIndexRoute
  AuthenticatedEnterpriseIdApplicationsAppIdRoute: typeof AuthenticatedEnterpriseIdApplicationsAppIdRoute
}

const AuthenticatedEnterpriseIdRouteRouteChildren: AuthenticatedEnterpriseIdRouteRouteChildren =
  {
    AuthenticatedEnterpriseIdEditRoute: AuthenticatedEnterpriseIdEditRoute,
    AuthenticatedEnterpriseIdIndexRoute: AuthenticatedEnterpriseIdIndexRoute,
    AuthenticatedEnterpriseIdApplicationsAppIdRoute:
      AuthenticatedEnterpriseIdApplicationsAppIdRoute,
  }

const AuthenticatedEnterpriseIdRouteRouteWithChildren =
  AuthenticatedEnterpriseIdRouteRoute._addFileChildren(
    AuthenticatedEnterpriseIdRouteRouteChildren,
  )

interface AuthenticatedEnterpriseRouteRouteChildren {
  AuthenticatedEnterpriseIdRouteRoute: typeof AuthenticatedEnterpriseIdRouteRouteWithChildren
  AuthenticatedEnterpriseNewRoute: typeof AuthenticatedEnterpriseNewRoute
  AuthenticatedEnterprisePocEnvironmentRoute: typeof AuthenticatedEnterprisePocEnvironmentRoute
  AuthenticatedEnterpriseIndexRoute: typeof AuthenticatedEnterpriseIndexRoute
  AuthenticatedEnterpriseActiveIndexRoute: typeof AuthenticatedEnterpriseActiveIndexRoute
  AuthenticatedEnterpriseApplicationsIndexRoute: typeof AuthenticatedEnterpriseApplicationsIndexRoute
  AuthenticatedEnterpriseMembersIdIndexRoute: typeof AuthenticatedEnterpriseMembersIdIndexRoute
}

const AuthenticatedEnterpriseRouteRouteChildren: AuthenticatedEnterpriseRouteRouteChildren =
  {
    AuthenticatedEnterpriseIdRouteRoute:
      AuthenticatedEnterpriseIdRouteRouteWithChildren,
    AuthenticatedEnterpriseNewRoute: AuthenticatedEnterpriseNewRoute,
    AuthenticatedEnterprisePocEnvironmentRoute:
      AuthenticatedEnterprisePocEnvironmentRoute,
    AuthenticatedEnterpriseIndexRoute: AuthenticatedEnterpriseIndexRoute,
    AuthenticatedEnterpriseActiveIndexRoute:
      AuthenticatedEnterpriseActiveIndexRoute,
    AuthenticatedEnterpriseApplicationsIndexRoute:
      AuthenticatedEnterpriseApplicationsIndexRoute,
    AuthenticatedEnterpriseMembersIdIndexRoute:
      AuthenticatedEnterpriseMembersIdIndexRoute,
  }

const AuthenticatedEnterpriseRouteRouteWithChildren =
  AuthenticatedEnterpriseRouteRoute._addFileChildren(
    AuthenticatedEnterpriseRouteRouteChildren,
  )

interface AuthenticatedMemberIdRouteRouteChildren {
  AuthenticatedMemberIdApplyRoute: typeof AuthenticatedMemberIdApplyRoute
  AuthenticatedMemberIdIndexRoute: typeof AuthenticatedMemberIdIndexRoute
}

const AuthenticatedMemberIdRouteRouteChildren: AuthenticatedMemberIdRouteRouteChildren =
  {
    AuthenticatedMemberIdApplyRoute: AuthenticatedMemberIdApplyRoute,
    AuthenticatedMemberIdIndexRoute: AuthenticatedMemberIdIndexRoute,
  }

const AuthenticatedMemberIdRouteRouteWithChildren =
  AuthenticatedMemberIdRouteRoute._addFileChildren(
    AuthenticatedMemberIdRouteRouteChildren,
  )

interface AuthenticatedMemberCompaniesRouteRouteChildren {
  AuthenticatedMemberCompaniesIndexRoute: typeof AuthenticatedMemberCompaniesIndexRoute
  AuthenticatedMemberCompaniesIdIndexRoute: typeof AuthenticatedMemberCompaniesIdIndexRoute
}

const AuthenticatedMemberCompaniesRouteRouteChildren: AuthenticatedMemberCompaniesRouteRouteChildren =
  {
    AuthenticatedMemberCompaniesIndexRoute:
      AuthenticatedMemberCompaniesIndexRoute,
    AuthenticatedMemberCompaniesIdIndexRoute:
      AuthenticatedMemberCompaniesIdIndexRoute,
  }

const AuthenticatedMemberCompaniesRouteRouteWithChildren =
  AuthenticatedMemberCompaniesRouteRoute._addFileChildren(
    AuthenticatedMemberCompaniesRouteRouteChildren,
  )

interface AuthenticatedMemberRouteRouteChildren {
  AuthenticatedMemberIdRouteRoute: typeof AuthenticatedMemberIdRouteRouteWithChildren
  AuthenticatedMemberCompaniesRouteRoute: typeof AuthenticatedMemberCompaniesRouteRouteWithChildren
  AuthenticatedMemberMyApplicationsRoute: typeof AuthenticatedMemberMyApplicationsRoute
  AuthenticatedMemberPocEnvironmentRoute: typeof AuthenticatedMemberPocEnvironmentRoute
  AuthenticatedMemberSavedRoute: typeof AuthenticatedMemberSavedRoute
  AuthenticatedMemberIndexRoute: typeof AuthenticatedMemberIndexRoute
}

const AuthenticatedMemberRouteRouteChildren: AuthenticatedMemberRouteRouteChildren =
  {
    AuthenticatedMemberIdRouteRoute:
      AuthenticatedMemberIdRouteRouteWithChildren,
    AuthenticatedMemberCompaniesRouteRoute:
      AuthenticatedMemberCompaniesRouteRouteWithChildren,
    AuthenticatedMemberMyApplicationsRoute:
      AuthenticatedMemberMyApplicationsRoute,
    AuthenticatedMemberPocEnvironmentRoute:
      AuthenticatedMemberPocEnvironmentRoute,
    AuthenticatedMemberSavedRoute: AuthenticatedMemberSavedRoute,
    AuthenticatedMemberIndexRoute: AuthenticatedMemberIndexRoute,
  }

const AuthenticatedMemberRouteRouteWithChildren =
  AuthenticatedMemberRouteRoute._addFileChildren(
    AuthenticatedMemberRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedEnterpriseRouteRoute: typeof AuthenticatedEnterpriseRouteRouteWithChildren
  AuthenticatedMemberRouteRoute: typeof AuthenticatedMemberRouteRouteWithChildren
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedEnterpriseRouteRoute:
    AuthenticatedEnterpriseRouteRouteWithChildren,
  AuthenticatedMemberRouteRoute: AuthenticatedMemberRouteRouteWithChildren,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GuideRoute: GuideRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TermsRoute: TermsRoute,
  ApplyEnterpriseRoute: ApplyEnterpriseRoute,
  ApplyMemberRoute: ApplyMemberRoute,
  ShowcaseSlugRoute: ShowcaseSlugRoute,
  ShowcaseIndexRoute: ShowcaseIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
